<template>
    <div>
        <title>{{ $t('notification_sf.text_8') }} - DOFFERO®</title>
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">       
        <div class="cont">
            <h1>{{ $t('notification_sf.text_9') }}</h1>
            <h3>{{ $t('notification_sf.text_10') }}</h3>
            <div class="first">
                <h3>{{ $t('notification_sf.text_11') }}</h3>
                <p>
                    <a target="_blank" href="https://www.superfaktura.sk/">www.superfaktura.sk</a> <br>
                    {{ $t('notification_sf.text_12') }} <a target="_blank" href="/admin/nastavenia/firma-a-kontakty">{{ $t('notification_sf.text_13') }}</a>.
                </p>
                <div class="form-group">
                    <div class="one">
                        <div class="form-floating">
                            <input  type="text" class="form-control" id="floatingInput" :placeholder="$t('notification_sf.text_14')" 
                                    v-model="email" />
                            <label for="floatingInput">{{ $t('notification_sf.text_14') }}</label>
                        </div>
                        <div class="form-floating mt-3">
                            <input  type="text" class="form-control" id="floatingInput" :placeholder="$t('notification_sf.text_15')" 
                                    v-model="key" />
                            <label for="floatingInput">{{ $t('notification_sf.text_15') }}</label>
                        </div>
                        <div class="form-group mt-3">
                            <div class="d-flex">
                                <input v-model="use_desc"
                                    type="checkbox" class="toggle">
                                <label class="block mb-0 mt-1" @click="use_desc = !use_desc" style="cursor:pointer;">
                                    Chcem do faktúry kopírovať aj popisy položiek
                                </label>
                            </div>
                        </div>  
                    </div>
                </div>
            </div>
            <div class="ulozit" @click="save">
                <span v-show="!saved">{{ $t('notification_sf.text_7') }}</span>
                <div v-show="saved" class=" lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    props: ['data'],
    data() {
        return {
            key: null,
            email: null,
            use_desc: false,
            saved:false
        }
    },
    created () {
        this.key = this.data.sf_key
        this.email = this.data.sf_email ? this.data.sf_email : this.data.email
        this.use_desc = this.data.sf_use_desc
    },
    methods: {
       save() {
            this.saved = true
            axios.patch(`/api/settings/integration/key`, {id: this.data.id, key: this.key, email: this.email, use_desc: this.use_desc})
            .then(response => {
                setTimeout(() => {
                    this.saved = false
                    this.$toast.success(this.$t('company.information_text_1'), {timeout: 2038});
                }, 500);
            })
        }
    },
    mounted () {
        $( ".tooltip_hover" ).hover(
            function() {
                $( this ).parent().find('.my_tooltip').css('opacity', '1');
            },
            function() {
                $( this ).parent().find('.my_tooltip').css('opacity', '0');
            },
        );
    },
}
</script>

<style lang="scss" scoped>
.cont{
    width: 1188px;
    margin: 0 auto;
    padding: 35px 0;
    @media only screen and (max-width: 1500px) {
        width: 95%;
    }   
    h1{
        @media only screen and (max-width: 600px) {
            width: 90%;
            margin: 0 auto;
        }
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 28px;
        text-align: center;
        color: #000000;
    }
    h3{
        width: 700px;
        @media only screen and (max-width: 600px) {
            width: 90%;
        }
        margin: 10px auto 27px auto;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 150%;
        text-align: center;
        color: #9598A7;
    }
    .first{
        width: 480px;
        padding: 24px;
        background: #FFFFFF;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        margin: 0 auto;
        h3{
            width: auto;
            margin: 0 0 4px 0;
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 21px;
            color: #212541;
            text-align: left;
        }
        p{
            font-family: "Roboto";
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 21px;
            color: #6d6e76;
            margin-top: 11px;
            text-decoration: none;
            a{
                font-family: 'Roboto';
                font-style: normal;
                font-weight: 400;
                font-size: 13px;
                line-height: 21px;
                color: #9598A7;
                margin-top: 11px;
                text-decoration: none;
                &:hover{
                    text-decoration: underline;
                }
            }
        }
        .form-group{
            display: flex;
            align-items: center;
            margin-bottom: 0px;
        }
        label{
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212541;
        }
        input[type="checkbox"] {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            -webkit-tap-highlight-color: transparent;
            cursor: pointer;
            margin: 0px 10px 0 0px;
            background: #C7D4EB;
            border-radius: 25px;
        }
        .toggle{
            height: 22px;
            width: 40px;
            display: inline-block;
            position: relative;
            margin: 0;
            border: none;
            background: #FFFFFF;
            border-radius: 3px;
            transition: all 0.2s ease;
            &:focus {
                outline: 0;
            }
            &:after {
                content: "";
                position: absolute;
                top: 4px;
                left: 3px;
                width: 14px;
                height: 14px;
                border-radius: 50%;
                background: white;
                box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
                transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
            }
            &:checked {
                border-color: #2ED8B6;
                background: #2ED8B6;
            }
            &:checked:after {
                transform: translatex(20px);
                
            }
        }
        .info{
            position: relative;
            height: 20px;
            margin-left: 10px;
            .info_icon{
                pointer-events: all;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                float: right;
                img{
                    width: 80%;
                    height: 80%;
                }
            }
            .my_tooltip{
                bottom: 22px;
                right: -7px;
            }
        }
        .agree_tooltip{
            position: relative;
        }
        .my_tooltip{
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 700;
            pointer-events: none;
            opacity: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 300px;
            background: #F3385A;
            box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
            border-radius: 6px;
            font-weight: 800;
            font-size: 14px;
            line-height: 18px;
            color: #fff;
            padding: 10px;
            position: absolute;
            top: unset;
            right: 15px;
            z-index: 10000;
            transition: opacity .5s ease-in-out;
            &::after{
                content: '';
                width: 15px;
                height: 15px;
                background: #F3385A;
                position: absolute;
                right: 10px;
                bottom: -3px;
                transform: rotate(45deg);
                border-radius: 3px;
            }
        }
    }
    .ulozit{
        width: 474px;
        height: 55px;
        @media only screen and (max-width: 600px) {
            width: 95%;
        }
        margin: 15px auto 0 auto;
        background: #2ED8B6;
        border-radius: 4px;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        color: #FFFFFF;
        cursor: pointer;
        transition: .5s all;
        &:hover{
            background: #23caa9;
        }
    }
    
    .one{
        .form-floating{
            width: 430px;
            height: 55px;
            margin: 0 auto;
            @media only screen and (max-width: 600px) {
                width: 95%;
            }
            input{
                display: flex !important;
                align-items: center !important;
                background: #FFFFFF;
                border: 1px solid #DDE3E8;
                box-sizing: border-box;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 16px;
                display: flex;
                align-items: center;
                color: #212541;
                padding-left: 10px;
            }
            label{
                display: flex !important;
                align-items: center !important;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 12px;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: #9598A7;
                padding-left: 10px;
            }
        }
        .odkaz{
            width: 430px;
            margin: 0 auto;
            @media only screen and (max-width: 600px) {
                width: 90%;
            }
            .odkaz_text{
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 150%;
                color:#9598A7;

            }
            .bottom{
                margin-top: 7px;
                display: flex;
                align-items: center;
                .odkaz_web{
                    font-family: Roboto;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 16px;
                    color: #9598A7;;
                }
                input{
                    font-family: Roboto;
                    font-style: normal;
                    font-weight: bold;
                    font-size: 14px;
                    line-height: 16px;
                    color: #212541;
                    background: transparent;
                    border: none;
                    border-bottom: 0.15rem solid;
                    width: 150px;
                }
            }

        
        }

    }
}
.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}
@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(24px, 0);
    }
}   
</style>